/**
 * @deprecated Legacy header - only used for desktop fallback in StoreHeader
 * New design uses StoreHeader directly
 */
export { default } from './main-header.legacy';
